/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{height:calc(100% - 15px);padding:10px 5px 0}.title[_ngcontent-%COMP%]{text-align:center;font-family:\"Helvetica Neue\",\"Segoe UI\",helvetica,verdana,sans-serif;font-size:14px;font-weight:445;line-height:16px}.show-loop-link[_ngcontent-%COMP%]{color:#337ab7;cursor:pointer}"];
export { styles as styles };
